import { render, staticRenderFns } from "./viplist.vue?vue&type=template&id=e93b2dfe&scoped=true&"
import script from "./viplist.vue?vue&type=script&lang=js&"
export * from "./viplist.vue?vue&type=script&lang=js&"
import style0 from "./viplist.vue?vue&type=style&index=0&id=e93b2dfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93b2dfe",
  null
  
)

export default component.exports